// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2ASbf","content":"styles_content__1rt4G","selectAll":"styles_selectAll__3iw44"};